import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Inject, Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { CellEditingStoppedEvent, ColDef, GridApi, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { ObjectUnsubscribedError, Observable, catchError, filter, map, of } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { WarehouseRowDetailsComponent } from '../warehouse-row-details/warehouse-row-details.component';
import { PalletRacksComponent } from 'src/app/pallet-racks/pallet-racks.component';
import { WarehousePositionsComponent } from '../warehouse-positions/warehouse-positions.component';
import { ShipmentListsModalComponent } from '../../shipment-lists/shipment-lists-modal/shipment-lists-modal.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-inventory-management',
  templateUrl: './inventory-management.component.html',
  styleUrls: ['./inventory-management.component.scss']
})
export class InventoryManagementComponent {

  @ViewChild(PalletRacksComponent) palletRacksComponent!: PalletRacksComponent; // ViewChild reference
  @ViewChild(WarehousePositionsComponent) warehousePositionsComponent!: WarehousePositionsComponent; // ViewChild reference

  @Output() warehouseSelected: EventEmitter<string> = new EventEmitter<string>();

  public gridReady = false;
  public filterReady = false;

  public detailCellRenderer: any = WarehouseRowDetailsComponent

  private gridApi!: GridApi;
  rows!: any[]
  warehouses!: any[]
  warehouse_customers: any[] = []
  warehouse_positions_data: any[] = []
  filteredCustomers: any[] = []

  filteredCustomer: string = ''

  // hold selected warehouse UUID from selection dropdown
  selectedWarehouse: string | null = null;

  // hold selectedf warehouse customer UUID from selection dropdown
  selectedWarehouseCustomer: string | null = null;

  // store warehouse_uuid
  uuid: string | null = "";

  // determine if inventory positions or pallet racks should be shown
  showInventoryPositions = true; // Set the initial state to true to display inventory positions

  total_positions: number = 0;
  total_positions_with_package: number = 0;
  total_sqft: number = 0;
  total_sqft_used: number = 0;
  total_sqft_left: number = 0;

  contactOrganizations: any[] = [];

  // Store model to be filtered
  filterValue: string = ''

  public themeClass: string = "ag-theme-ulaap";

  constructor(private http: HttpClient, private route: ActivatedRoute, private dialog: MatDialog, private router: Router) { }

  ngOnInit(): void {
    // get warehouse_uuid
    this.route.paramMap.subscribe(params => {
      this.uuid = params.get('uuid');
    });

    const warehouse_url = "/api/inventory/inventory_warehouses.php"
    this.http.get(warehouse_url).subscribe((response: any) => {
      if (response) {
        this.warehouses = response.data;
        // Find the FBI warehouse object for the intial value of the warehouse dropdown mat-select
        const warehouse = this.warehouses.find(warehouse => warehouse.inventory_warehouse_uuid === this.uuid)

        // If warehouse found set initial UUID to the mat-select
        if (warehouse) {
          this.selectedWarehouse = warehouse.inventory_warehouse_uuid;
        }
      }
    })

    // initialize Positions data and customer dropdown
    this.updatePositionsData()

    // filter customer data for customer select dropdown
    // if (this.filterReady == true) {
    //   this.filterCustomersByPositionData()
    // }

    // console.log('this is the hello world', this.contact_names);
    // this.getTest("90a8a818-1107-4f16-9609-b0c7d06d9eac");
  }

  navigateToReports(){
    this.router.navigate(['/warehouse_reports', this.uuid]);
  }

  // display product space accumulated of all products in v_products containing the respective warehouse_uuid
  calculateProductMetrics(): void {
    const prodmetrics_url = `/api/inventory/inventory_warehouse_product_metrics.php?uuid=${this.uuid}`;
    this.http.get(prodmetrics_url).subscribe((response: any) => {
      if (response) {
        // Round values to 2 decimal places
        const total_products = response.total_products;
        const total_sqr_feet = parseFloat(response.total_square_feet).toFixed(2);
        const total_cubic_feet = parseFloat(response.total_cubic_feet).toFixed(2);
  
        // Open the dialog with rounded values
        this.dialog.open(ProductMetricsDialogComponent, {
          data: {
            total_products,
            total_square_feet: total_sqr_feet,
            total_cubic_feet: total_cubic_feet
          }
        });
      }
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  updatePositionsData(): void {

    const positions_url = `/api/inventory/inventory_warehouse_positions.php?uuid=${this.uuid}`
    this.http.get(positions_url).subscribe((response: any) => {
      if (response) {
        this.warehouse_positions_data = response.data;
        this.total_positions = response.total_positions;
        this.total_positions_with_package = response.total_positions_with_package;
        this.total_sqft = response.total_sqft;
        this.total_sqft_used = response.total_sqft_used;
        this.total_sqft_left = response.total_sqft_left;

        this.contactOrganizations = Array.from(
          new Set(this.warehouse_positions_data.map(position => position.most_common_contact_organization))
        ).map(contactOrganization => contactOrganization === null ? 'ALL CUSTOMERS' : contactOrganization)
          .filter(contactOrganization => contactOrganization != '');

        // const warehouse_customer_url = `/api/inventory/inventory_warehouse_customers.php?uuid=${this.uuid}`
        // this.http.get(warehouse_customer_url).subscribe((response: any) => {
        //   if (response) {
        //     this.warehouse_customers = response;
        //     this.filterCustomersByPositionData()
        //   }
        // })
      }
    })

  }

  onWarehouseSelect(): void {
    this.uuid = this.selectedWarehouse

    // update header positions data and customer dropdown
    this.updatePositionsData()

    if (this.selectedWarehouse) {
      this.router.navigate(['/inventory_management', this.selectedWarehouse]);

      if (!this.showInventoryPositions) {
        this.palletRacksComponent.uuid = this.selectedWarehouse
        this.palletRacksComponent.loadRackData()
      } else {

        // update positions grid data
        this.warehousePositionsComponent.uuid = this.selectedWarehouse
        this.warehousePositionsComponent.updateGridData()
      }

    }
  }

  onCustomerSelect(event: any): void {

    const customerSelected = event.value

    this.warehousePositionsComponent.filterCustomer(customerSelected)

    // console.log('customer id', this.selectedWarehouseCustomer)

    // if (this.selectedWarehouseCustomer == "ALL CUSTOMERS") {

    //   const positions_url = `/api/inventory/inventory_warehouse_positions.php?uuid=${this.uuid}`
    //   this.http.get(positions_url).subscribe((response: any) => {
    //     if (response) {
    //       this.total_positions = response.total_positions;
    //       this.total_positions_with_package = response.total_positions_with_package;
    //       this.total_sqft = response.total_sqft;
    //       this.total_sqft_used = response.total_sqft_used;
    //       this.total_sqft_left = response.total_sqft_left;
    //     }
    //   })

    //   // update positions grid data
    //   this.warehousePositionsComponent.updateGridData()

    // } else {

    //   const positions_url = `/api/inventory/inventory_warehouse_positions.php?uuid=${this.uuid}&contact_uuid=${this.selectedWarehouseCustomer}`
    //   this.http.get(positions_url).subscribe((response: any) => {
    //     if (response) {
    //       this.total_positions = response.total_positions;
    //       this.total_positions_with_package = response.total_positions_with_package;
    //       this.total_sqft = response.total_sqft;
    //       this.total_sqft_used = response.total_sqft_used;
    //       this.total_sqft_left = response.total_sqft_left;
    //     }
    //   })
    // }

    // update positions grid data with data of the customer selected
    // this.warehousePositionsComponent.selectedWarehouseCustomer = this.selectedWarehouseCustomer
    // this.warehousePositionsComponent.updateGridDataWithContact()

  }

  toggleComponent(): void {
    this.showInventoryPositions = !this.showInventoryPositions;
  }

  exportCsv(): void {
    this.warehousePositionsComponent.onBtnExport()
  }

  onProductFilterChange() {
      console.log('Filter value is now: ', this.filterValue);
      this.warehousePositionsComponent.filterProduct(this.filterValue);
  }

  
  uploadInventoryFile() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '550px'; // You can use pixels or other units
    dialogConfig.height = '180px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Upload Inventory File',
        modalMessage: {inventory_warehouse_uuid: this.uuid},
      },
    };
    this.dialog.open(ShipmentListsModalComponent, dialogConfig);
  }

  filterCustomersByPositionData(): void {
    // if (!this.warehouse_positions_data) {
    //   // If warehouse_positions_data is not available, reset warehouse_customers array
    //   this.filteredCustomers = this.warehouse_customers.slice();
    //   return;
    // }

    // Get all unique contact organizations from warehouse_positions_data
    const contactOrganizations = new Set(this.warehouse_positions_data.map(position => position.most_common_contact_organization));

    // Filter warehouse_customers array based on matching contact organizations
    // this.filteredCustomers = this.warehouse_customers.filter(customer =>
    //   contactOrganizations.has(customer.inventory_warehouse_customer_name)
    // );

    // this.filteredCustomers.unshift({
    //   inventory_warehouse_customer_name: "ALL CUSTOMERS",
    //   inventory_warehouse_customer_contact_uuid: "ALL CUSTOMERS"
    // });
  }

}

// component for popup dialog for product metric function
@Component({
  selector: 'app-product-metrics-dialog',
  template: `
    <h1 mat-dialog-title>Product Metrics</h1>
    <div mat-dialog-content>
      <p style="font-size: 1.2em;">
        Total space used up by all the products in the database for this warehouse:
      </p>
      <div style="margin-top: 15px;">
        <p>Total Products: <span style="font-weight: bold;">{{ data.total_products }}</span></p>
        <p>Total Square Feet: <span style="font-weight: bold;">{{ data.total_square_feet }} sq ft</span></p>
        <p>Total Cubic Feet: <span style="font-weight: bold;">{{ data.total_cubic_feet }} cu ft</span></p>
      </div>
    </div>
  `,
  styles: [
    `
      mat-dialog-title {
        font-size: 1.5em;
        font-weight: bold;
      }

      mat-dialog-content p {
        margin: 5px 0;
      }

      mat-dialog-actions {
        margin-top: 20px;
      }
    `
  ]
})
export class ProductMetricsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
